import React, { PureComponent } from 'react';
import * as R from 'ramda';
import { connect } from 'react-redux';
import { getTranslate } from 'react-localize-redux';
import Section from '../../components/section/section';
import './account.less';
import { fetchLenderAccounts, setSelectedAccount } from './accountActions';
import { Alert } from 'antd';
import { getError, isBusy, withActions } from 'actionware';
import AccountDetails from './details';
import AccountLoans from './loans';
import LoanDetails from './loanDetails';
import LoansMobile from './loansMobile';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';

@withRouter
@connect(
  ({
    localize,
    account: { accounts, selectedAccountId, activeLoans, repaidLoans },
    router: { location }
  }) => ({
    translate: getTranslate(localize),
    loading: isBusy(fetchLenderAccounts),
    error: getError(fetchLenderAccounts),
    location
  })
)
@withActions({
  fetchLenderAccounts,
  setSelectedAccount
})
export default class Account extends PureComponent {
  static propTypes = {
    match: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired
  };

  componentDidMount() {
    const { match, selectedAccountId } = this.props;
    const routeAccountId = R.path(['params', 'accountId'], match);
    if (routeAccountId && !selectedAccountId) {
      this.props.setSelectedAccount(routeAccountId);
    } else {
      this.props.fetchLenderAccounts();
    }
    window.scrollTo(0, 0);
  }

  render() {
    const { translate, loading, error } = this.props;

    if (loading) {
      return <div />;
    }

    if (error) {
      return (
        <Alert
          message={translate('generic.loadingErrorCaption')}
          description={translate('generic.loadingErrorMessage')}
          type="error"
          showIcon
        />
      );
    }

    return (
      <div className={'account'}>
        <AccountDetails />
        { /* <AccountStatistic /> */ }
        <LoansMobile />
        <Section className={'account-loans'}>
          <AccountLoans />
          <LoanDetails />
        </Section>
      </div>
    );
  }
}
